export default __webpack_public_path__ + "static/bg-1-db4505e60032e6af77d7ac4c532b22e4.png";